import { render, staticRenderFns } from "./videoloading.vue?vue&type=template&id=4130b78e"
import script from "./videoloading.vue?vue&type=script&lang=js"
export * from "./videoloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports